module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.items.length) ? _c('title-block', {
    attrs: {
      "title": "Special Collection Archives",
      "color-theme": "primary-color"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.text))])])
  }))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5969fa3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/SpecialCollectionArchivesComponent.vue
// module id = 1433
// module chunks = 1